export const getDetail = async (sendAndWaitWs, id) => {
  const request = { id };
  const response = await sendAndWaitWs(
    "/inspire/getDetail",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const batchGet = async (sendAndWaitWs, ids) => {
  const response = await sendAndWaitWs(
    "/inspire/batchGet",
    JSON.stringify({ ids })
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getPopularityList = async (
  sendAndWaitWs,
  size,
  metricKey,
  nextToken
) => {
  const request = { size, metricKey, nextToken };
  const response = await sendAndWaitWs(
    "/inspire/premade/popularity/list",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getSharePopularity = async (
  sendAndWaitWs,
  size,
  metricKey,
  nextToken
) => {
  const request = { size, metricKey, nextToken };
  const response = await sendAndWaitWs(
    "/inspire/shared/popularity/list",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const searchPremades = async (sendAndWaitWs, searchText) => {
  const request = { searchText };
  const response = await sendAndWaitWs(
    "/inspire/premade/search",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};
